import { useCompanyData } from "../../../lib/useMockData";

export default function HeroSection() {
  const { heroData } = useCompanyData();
  return (
    <section className="relative h-[360px] md:h-[480px] lg:h-[540px] overflow-hidden">
      <img
        src={heroData.image}
        alt="運営会社"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-airdoa-navy/40 via-airdoa-navy/30 to-airdoa-navy/60" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
        <p className="text-xs md:text-sm tracking-ultra text-airdoa-gold mb-4 md:mb-5">
          COMPANY
        </p>
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold text-white leading-tight">
          {heroData.title}
        </h1>
        <p className="mt-5 max-w-2xl text-sm md:text-base text-white/70 leading-[1.9]">
          {heroData.subtitle}
        </p>
      </div>
    </section>
  );
}
